/**
 * "View bag" opens the cart drawer.
 *
 * The store never sends anyone to /cart - the drawer is the bag everywhere - so these
 * links stay real anchors for no-JS and for opening in a new tab, but a plain click
 * opens the drawer instead of navigating away from whatever the shopper was browsing.
 *
 * Delegated on the document because the panels and looks that contain these links are
 * rendered and re-rendered after the page loads.
 */
(() => {
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href$="/cart"], a[href*="/cart?"], .quick-shop__view-bag, .dt-look__view-bag');
    if (!link) return;
    // Leave modified clicks alone: cmd/ctrl-click, middle click and new-tab still work.
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;

    const drawer = document.querySelector('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return;

    event.preventDefault();
    // Make sure the drawer shows the current bag rather than whatever it held at load.
    const refreshed = window.dtRefreshCart ? window.dtRefreshCart() : Promise.resolve();
    refreshed.then(() => drawer.open());
  });
})();
